import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPage() {
  const navigate = useNavigate();
  return (
    <div style={{ maxWidth:800, margin:'0 auto', padding:'20px 0' }}>
      <button onClick={() => navigate(-1)} className="btn-ghost" style={{ marginBottom:20, padding:'8px 16px', fontSize:13 }}>← Back</button>
      <div className="card" style={{ padding:'32px' }}>
        <div style={{ fontFamily:"'Righteous',sans-serif", fontSize:28, marginBottom:4 }} className="brand-text">NAIJAPREDICT</div>
        <h1 style={{ fontSize:22, fontWeight:700, marginBottom:4 }}>Privacy Policy</h1>
        <div style={{ fontSize:12, color:'var(--muted)', marginBottom:28 }}>Last updated: July 2026</div>

        {[
          {
            title: '1. Information We Collect',
            body: `We collect the following information when you use NaijaPredict:\n\n• Account information: Name, email address, phone number, Telegram ID and username\n• Transaction data: Stakes placed, amounts, payouts, deposits and withdrawals\n• Device information: IP address, browser type, device type\n• Bank details: Account number, bank name and account name (for withdrawals only)\n• Usage data: Pages visited, features used, time spent on platform`
          },
          {
            title: '2. How We Use Your Information',
            body: `We use your information to:\n\n• Provide and improve our prediction market services\n• Process deposits, payouts and withdrawals\n• Detect and prevent fraud and multiple account abuse\n• Send you transaction confirmations and market updates\n• Respond to support requests\n• Comply with legal obligations\n• Send promotional communications (you may opt out at any time)`
          },
          {
            title: '3. Data Storage & Security',
            body: `Your data is stored on secure servers hosted in the European Union. We use industry-standard encryption (SSL/TLS) to protect data in transit. Passwords are hashed using bcrypt and never stored in plain text. Bank account details are encrypted at rest and used only for processing withdrawals. We retain your data for as long as your account is active and for 2 years after account closure for legal compliance.`
          },
          {
            title: '4. Data Sharing',
            body: `We do not sell your personal data to third parties. We share data only with:\n\n• Flutterwave — for payment processing and bank transfers\n• Telegram — for bot authentication and notifications\n• Kudisms — for OTP SMS delivery\n• Legal authorities — when required by law\n\nAll third-party providers are bound by their own privacy policies and data protection agreements.`
          },
          {
            title: '5. Cookies & Tracking',
            body: `NaijaPredict uses cookies and local storage to:\n\n• Keep you logged in (JWT session token)\n• Remember your theme preference (light/dark mode)\n• Analyse platform usage via anonymous analytics\n\nYou can clear cookies at any time via your browser settings. Disabling cookies will log you out of the platform.`
          },
          {
            title: '6. Your Rights',
            body: `You have the right to:\n\n• Access your personal data at any time via your Profile page\n• Correct inaccurate information by contacting support\n• Delete your account and all associated data (subject to legal retention requirements)\n• Withdraw consent for marketing communications\n• Request a copy of your data in machine-readable format\n\nTo exercise any of these rights, contact support@naijapredict.net.`
          },
          {
            title: '7. Children\'s Privacy',
            body: `NaijaPredict is not intended for users under the age of 18. We do not knowingly collect personal information from minors. If we discover that a minor has registered, their account will be immediately closed and all funds refunded.`
          },
          {
            title: '8. Telegram Integration',
            body: `When you use Telegram Login on NaijaPredict, we receive your Telegram ID, name and username from Telegram. This data is used solely to identify your account. We do not have access to your Telegram messages or contacts. Notifications sent via our bot are one-way and you can block the bot at any time.`
          },
          {
            title: '9. Changes to This Policy',
            body: `We may update this Privacy Policy from time to time. We will notify you of significant changes via Telegram or email. Continued use of the platform after notification constitutes acceptance of the updated policy.`
          },
          {
            title: '10. Contact Us',
            body: `For any privacy-related questions or requests:\n\n📧 Email: support@naijapredict.net\n🤖 Telegram: @NaijaPredict_Bot\n🌐 Web: naijapredict.net`
          },
        ].map((s,i) => (
          <div key={i} style={{ marginBottom:24 }}>
            <h2 style={{ fontSize:15, fontWeight:700, color:'var(--orange)', marginBottom:8 }}>{s.title}</h2>
            <p style={{ fontSize:13, color:'var(--text2)', lineHeight:1.8, whiteSpace:'pre-line' }}>{s.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
